// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"2442":"b0879f7d5e4cd806","2741":"653c787f2490dc24","5443":"4b6455210b829ef8","6350":"b68eff939cd937d4","7856":"284508e5f767ae9d","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};